export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Slider.vue?vue&type=template&id=769aa149"


//////////////////
// WEBPACK FOOTER
// ./src/components/Slider.vue?vue&type=template&id=769aa149
// module id = 1449
// module chunks = 31